var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464646"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.848,
    x2: 308.793,
    xlinkHref: "#lg1",
    y1: 48.283,
    y2: 120.227
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.5,
    x2: 256.5,
    y1: 45.333,
    y2: 85.356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464646",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3321,
    stopColor: "#3e3e3e",
    stopOpacity: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#282828",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfe7fd"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.487,
    x2: 287.306,
    xlinkHref: "#lg2",
    y1: 41.846,
    y2: 103.665
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8aaadc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8aaadc"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.5,
    x2: 256.5,
    xlinkHref: "#lg3",
    y1: 57.333,
    y2: 83.342
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.434,
    x2: 286.434,
    xlinkHref: "#lg3",
    y1: 86.399,
    y2: 12.399
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.668,
    x2: 106.482,
    y1: 59.332,
    y2: 97.146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7e07d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e69642"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.342,
    x2: 93.009,
    y1: 69.798,
    y2: 93.132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d52c1c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d12c1e",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5735,
    stopColor: "#c42c23",
    stopOpacity: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8721,
    stopColor: "#af2b2c",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a42b31"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.08,
    x2: 366.133,
    xlinkHref: "#lg1",
    y1: 100.08,
    y2: 408.133
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464646",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.047,
    x2: 236.318,
    xlinkHref: "#lg4",
    y1: 505.047,
    y2: 278.318
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 377,
    y2: 538.003
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.277,
    x2: 327.151,
    xlinkHref: "#lg1",
    y1: 238.277,
    y2: 369.151
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 246.667,
    y2: 170.655
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 331,
    y2: 417
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.385,
    x2: 357.461,
    xlinkHref: "#lg4",
    y1: 261.387,
    y2: 399.463
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-1 0 0 -1 -754 -9602)",
    gradientUnits: "userSpaceOnUse",
    x1: -1022.615,
    x2: -884.539,
    xlinkHref: "#lg4",
    y1: -9912.613,
    y2: -9774.537
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.001,
    x2: 276.134,
    xlinkHref: "#lg4",
    y1: 223.999,
    y2: 318.132
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.151,
    x2: 371.031,
    xlinkHref: "#lg2",
    y1: 191.151,
    y2: 413.031
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-1 0 0 -1 -754 -9602)",
    gradientUnits: "userSpaceOnUse",
    x1: -1102.1,
    x2: -918.015,
    xlinkHref: "#lg2",
    y1: -9992.1,
    y2: -9808.015
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 371,
    y2: 463.005
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 456,
    x2: 421.584,
    xlinkHref: "#lg1",
    y1: 176,
    y2: 141.584
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m373.73 97h-234.46l26.553-81.172c3.088-9.442 11.896-15.828 21.831-15.828h137.693c9.934 0 18.743 6.386 21.831 15.828z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.27 97h234.46l-20.608-63h-193.244z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.114 94.333h-173.228l19.618-59.972c2.282-6.976 8.79-11.694 16.13-11.694h101.732c7.34 0 13.848 4.718 16.13 11.694z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.114 94.333h-173.228l19.618-59.972c2.282-6.976 8.79-11.694 16.13-11.694h101.732c7.34 0 13.848 4.718 16.13 11.694z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.886 94.333h173.228l-13.63-41.666h-145.968z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130 102.498h-77.377v-34.01c0-9.382 7.606-16.988 16.988-16.988h43.4c9.382 0 16.988 7.606 16.988 16.988v34.01z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130 102.498h-77.377v-34.01c0-9.382 7.606-16.988 16.988-16.988h43.4c9.382 0 16.988 7.606 16.988 16.988v34.01z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.41 510h-296.82c-58.868 0-106.59-47.722-106.59-106.59v-212.82c0-58.868 47.722-106.59 106.59-106.59h296.82c58.868 0 106.59 47.722 106.59 106.59v212.82c0 58.868-47.722 106.59-106.59 106.59z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257 119.758c-98.834 0-179.242 80.408-179.242 179.242 0 52.414 22.616 99.643 58.599 132.448l78.552 78.552h188.501c58.868 0 106.59-47.722 106.59-106.59v-104.501l-120.553-120.553c-32.805-35.983-80.034-58.598-132.447-58.598z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 344.628v58.782c0 58.868 47.722 106.59 106.59 106.59h296.82c58.868 0 106.59-47.722 106.59-106.59v-58.782z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 297,
    fill: "url(#SVGID_11_)",
    r: 126
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 297,
    fill: "url(#SVGID_12_)",
    r: 126
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.871 323.764c12.305 56.663 62.835 99.236 123.129 99.236s110.824-42.573 123.129-99.236z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.288 231.712c-16.707-16.711-39.793-27.046-65.288-27.046s-48.581 10.335-65.288 27.046c-16.711 16.707-27.046 39.793-27.046 65.288 0 50.994 41.34 92.333 92.333 92.333 25.495 0 48.581-10.335 65.288-27.046 16.711-16.707 27.046-39.793 27.046-65.288s-10.335-48.58-27.045-65.287z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.712 362.288c16.707 16.711 39.793 27.046 65.288 27.046s48.581-10.335 65.288-27.046c16.711-16.707 27.046-39.793 27.046-65.288 0-50.994-41.34-92.333-92.333-92.333-25.495 0-48.581 10.335-65.288 27.046-16.711 16.707-27.046 39.793-27.046 65.288s10.335 48.58 27.045 65.287z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.918 345.082c12.304 12.307 29.306 19.918 48.082 19.918s35.778-7.611 48.082-19.918c12.307-12.304 19.918-29.306 19.918-48.082 0-37.555-30.445-68-68-68-18.776 0-35.778 7.611-48.082 19.918-12.307 12.304-19.918 29.306-19.918 48.082s7.611 35.778 19.918 48.082z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 476.242c-98.834 0-179.242-80.408-179.242-179.242s80.408-179.242 179.242-179.242 179.242 80.408 179.242 179.242-80.408 179.242-179.242 179.242zm0-313.484c-74.021 0-134.242 60.221-134.242 134.242s60.221 134.242 134.242 134.242 134.242-60.221 134.242-134.242-60.221-134.242-134.242-134.242z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 139.854c86.65 0 157.146 70.495 157.146 157.146s-70.496 157.146-157.146 157.146-157.146-70.496-157.146-157.146 70.496-157.146 157.146-157.146zm0 274.839c64.896 0 117.693-52.797 117.693-117.693s-52.797-117.693-117.693-117.693-117.693 52.797-117.693 117.693 52.797 117.693 117.693 117.693z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.681 298c-.541 64.437-53.119 116.693-117.681 116.693s-117.14-52.256-117.681-116.693h-61.548c.541 98.375 80.729 178.242 179.229 178.242s178.688-79.867 179.229-178.242z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 428.333,
    cy: 148.333,
    fill: "url(#SVGID_20_)",
    r: 30
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.fdce267c9507f30b2d32efa93d173425.svg";
export { ForwardRef as ReactComponent };